// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationId } from './Fermentation';
import { fermentationControllerModeEnum } from './FermentationControllerModeEnum';
import { fermentationParameterTypeId } from './FermentationParameterType';
import { fermentationLineTypeId } from './FermentationLineType';
import { operatorId } from './Operator';
import { brewcontrolEventId } from './BrewcontrolEvent';
import { brewcontrolRunId } from './BrewcontrolRun';
import { brewcontrolConfigVersionId } from './BrewcontrolConfigVersion';
import { z } from 'zod';
export const fermentationControllerModeId = (z.number());
export const fermentationControllerMode = z.object({
    id: fermentationControllerModeId,
    fermentation_id: fermentationId,
    effective_at: z.date(),
    mode: fermentationControllerModeEnum,
    parameter_type_id: fermentationParameterTypeId.nullable(),
    line_type_id: fermentationLineTypeId.nullable(),
    operator_id: operatorId.nullable(),
    reason: z.string().nullable(),
    brewcontrol_event_id: brewcontrolEventId.nullable(),
    brewcontrol_run_id: brewcontrolRunId.nullable(),
    wiring_version_id: brewcontrolConfigVersionId.nullable(),
    controller_name: z.string().nullable(),
    created_at: z.date(),
    created_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
});
export const fermentationControllerModeInitializer = z.object({
    id: fermentationControllerModeId.optional(),
    fermentation_id: fermentationId,
    effective_at: z.date(),
    mode: fermentationControllerModeEnum,
    parameter_type_id: fermentationParameterTypeId.optional().nullable(),
    line_type_id: fermentationLineTypeId.optional().nullable(),
    operator_id: operatorId.optional().nullable(),
    reason: z.string().optional().nullable(),
    brewcontrol_event_id: brewcontrolEventId.optional().nullable(),
    brewcontrol_run_id: brewcontrolRunId.optional().nullable(),
    wiring_version_id: brewcontrolConfigVersionId.optional().nullable(),
    controller_name: z.string().optional().nullable(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
export const fermentationControllerModeMutator = z.object({
    id: fermentationControllerModeId.optional(),
    fermentation_id: fermentationId.optional(),
    effective_at: z.date().optional(),
    mode: fermentationControllerModeEnum.optional(),
    parameter_type_id: fermentationParameterTypeId.optional().nullable(),
    line_type_id: fermentationLineTypeId.optional().nullable(),
    operator_id: operatorId.optional().nullable(),
    reason: z.string().optional().nullable(),
    brewcontrol_event_id: brewcontrolEventId.optional().nullable(),
    brewcontrol_run_id: brewcontrolRunId.optional().nullable(),
    wiring_version_id: brewcontrolConfigVersionId.optional().nullable(),
    controller_name: z.string().optional().nullable(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=FermentationControllerMode.js.map